import { Banknote, Droplets, ShieldCheck, Gauge, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "../Reveal";

const features = [
  {
    icon: Banknote,
    title: "Fast Deposit and Withdraw",
    desc: "Deposit or withdraw INR in seconds. No delays, no confusion — just seamless transactions.",
  },
  {
    icon: Droplets,
    title: "Deep Liquidity",
    desc: "Best prices, faster trades. We pull liquidity from top global venues for unmatched execution.",
  },
  {
    icon: ShieldCheck,
    title: "KYC & Blockchain Security",
    desc: "Built-in KYC, AML & blockchain monitoring so you're always trading safe.",
  },
  {
    icon: Gauge,
    title: "Trading Efficiency",
    desc: "Trade at top speed with minimal fees. Because efficiency shouldn't be expensive.",
  },
];

export default function WhyChoose() {
  return (
    <section className="cm-landing-section bg-white" data-testid="why-choose">
      <div className="cm-container">
        <Reveal variant="fade-up" className="text-center max-w-[800px] mx-auto mb-14 lg:mb-16">
          <div className="cm-landing-section-label mb-4">Best in class</div>
          <h2 className="cm-landing-section-title">
            Pro trading for everyone
          </h2>
          <p className="mt-5 text-[15px] leading-[1.85] text-cm-grey max-w-[640px] mx-auto">
            A full-stack crypto platform for spot and OTC — with institutional-grade custody,
            compliance, and support.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal
                key={f.title}
                variant="fade-up"
                delay={i * 80}
                className="cm-landing-feature-card p-6 lg:p-7 flex flex-col"
                data-testid={`feature-${i}`}
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cm-blue to-cm-blue-vivid grid place-items-center mb-5 shadow-[0_12px_24px_-12px_rgba(2,44,237,0.5)]">
                  <Icon size={22} className="text-white" strokeWidth={1.75} aria-hidden />
                </div>
                <h3 className="text-[17px] font-bold text-cm-navy mb-3">{f.title}</h3>
                <p className="text-[13px] leading-[1.75] text-cm-grey flex-1">{f.desc}</p>
              </Reveal>
            );
          })}
        </div>

        <Reveal variant="fade-up" delay={200} className="mt-12 text-center">
          <Link
            to="/markets"
            className="inline-flex items-center gap-2 text-[14px] font-bold text-cm-blue hover:gap-3 transition-all"
            data-testid="why-choose-explore-markets"
          >
            Explore markets
            <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
